/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFilesOff = createReactComponent("outline", "files-off", "IconFilesOff", [["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823", "key": "svg-1" }], ["path", { "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

export { IconFilesOff as default };
//# sourceMappingURL=IconFilesOff.mjs.map
